<div *ngIf="showUndoMessage" @toggleNotification class="content-notification-wrap">
  <div class="content-notification" [ngClass]="{ 'notification-success': type === 'success' }">
    <div class="notification-icon">
      <span class="icon-i-checkmark-circle"></span>
    </div>
    <div class="notification-text">
      <ng-container *ngFor="let message of messages">
        <p [innerHTML]="message"></p>
      </ng-container>
    </div>
  </div>
</div>
